/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../script.js` and enqueued in
 * `../functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
import "./$.js";
import "./polyfills.js";
import "./imports.js";

function openOsanoDrawer() {
  const consentManager = window.Osano?.cm;

  if (typeof consentManager?.showDrawer === "function") {
    consentManager.showDrawer("preferences");
    return true;
  }

  const fallbackTrigger = $(
    ".osano-cm-widget, .osano-cm-manage-cookies, [data-cc='c-settings']"
  );

  if (fallbackTrigger instanceof HTMLElement) {
    fallbackTrigger.click();
    return true;
  }

  return false;
}

document.addEventListener("click", (event) => {
  const link = event.target.closest("a.osano-drawer");
  if (!(link instanceof HTMLAnchorElement)) return;

  event.preventDefault();
  openOsanoDrawer();
});

// Handles invoker with custom command.
document.addEventListener("command", (event) => {
  const { command, source: invoker, target } = event;

  // Handles filter command with XPath.
  // Example: 
  //   `--filter/*[contains(., 'Press Release')]`
  //   `--filter/*[@data-category = 'Press Release']`
  if (command.startsWith("--filter/")) {
    // Toggle other invokers with the same type of command.
    const filters = $$(`[command^="--filter/"][commandfor="${target.id}"]`);
    for (const filter of filters) {
      filter.setAttribute("aria-selected", `${filter === invoker}`);
    }

    const selector = `.${command.slice(8)}`;
    const matches = document.evaluate(
      selector, target,  
      null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null
    );

    // Hides all siblings first, then shows matched elements.
    const siblings = matches.snapshotItem(0).parentElement.children;
    for (const sibling of siblings) {
      sibling.hidden = true;
    }
    for (let i = 0; i < matches.snapshotLength; i++) {
      matches.snapshotItem(i).hidden = false;
    }
  }
}, true);